import React, { useEffect } from 'react'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'

import AboutImage from './../../../assets/img/about/about.jpg'

import './index.css'

export default function About() {

    useEffect(() => {
        console.log('about section mounted')
    }, [])


    return (
        <section className="About" id="about">
            <div className="content">
                <Container>
                    <Row>
                        <Col className="center-horizontal-vertical" md={6}>
                            <div className="container-image">
                                <img src={AboutImage} className="img-fluid" alt="about"/>
                            </div>
                        </Col>

                        <Col className="center-vertical" md={6}>
                            <h1 className="section-title">Sobre nós</h1>

                            <p className="grey-text">
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
                                and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,
                                remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages,
                                and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                            </p>

                            <Button variant="primary">
                                Saiba mais
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </div>
        </section>
    )
}